// Shared look for filter fields (FilterMultiSelect + table search) so they always match.
// Accent = blue, the same colour as the checkboxes, so each field uses a single colour.
export const FIELD = {
  accent: "#2563eb",
  accentHover: "#1d4ed8",
  border: "#c7d7f5", // soft blue-grey resting border
  bg: "#ffffff",
  focusRing: "rgba(37,99,235,0.14)",
  check: "#2563eb", // checkbox / selection colour (blue)
  checkIdle: "#cbd5e1",
  selectedBg: "#eff6ff", // selected option row
  selectedHoverBg: "#dbeafe",
  selectedText: "#1e3a8a",
  text: "#1e293b",
  muted: "#64748b",
  placeholder: "#94a3b8",
  height: 44,
};

// Uppercase label shown above the field
export const fieldLabelSx = {
  display: "block",
  mb: 0.75,
  ml: 0.25,
  fontSize: 12,
  fontWeight: 800,
  letterSpacing: 0.8,
  textTransform: "uppercase",
  color: FIELD.muted,
};

// Outlined input root (works for both Select root and TextField's .MuiOutlinedInput-root)
export const fieldRootSx = {
  height: FIELD.height,
  borderRadius: 3,
  bgcolor: FIELD.bg,
  fontSize: 15,
  fontWeight: 500,
  color: FIELD.text,
  transition: "background-color .15s ease, box-shadow .15s ease",
  "& .MuiOutlinedInput-notchedOutline": { borderWidth: "1.5px", borderColor: FIELD.border },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: FIELD.accent },
  "&.Mui-focused": { bgcolor: "#fff", boxShadow: `0 0 0 4px ${FIELD.focusRing}` },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderWidth: "1.5px", borderColor: FIELD.accent },
  "& input::placeholder": { color: FIELD.placeholder, opacity: 1 },
};
